import { languages } from 'utils/translationHandlers';

export const INPUT_EMAIL = 'email';
export const INPUT_PASS = 'password';
export const INPUT_LANGUAGE = 'language';
export const INPUT_ROLE = 'role';
export const INPUT_CURRENT_COUNTRY = 'country';
export const INPUT_COMMUNICATION = 'emails';
export const INPUT_PHONE = 'phone_number';
export const INPUT_CONFIRM_PASS = 're_password';

export const COMM_FALSE = 0;
export const COMM_TRUE = 1;

export const ROLE_MEMBER = 'member';
export const ROLE_MENTOR = 'mentor';

export const getTermsAndConditionsByLang = lang => {
  switch (lang) {
    case languages.ES:
      return 'https://s3.amazonaws.com/assets.bridgeforbillions.org/docs/ES_Terminos_y_Condiciones_React_2021.pdf';
    case languages.EN:
    default:
      return 'https://s3.amazonaws.com/assets.bridgeforbillions.org/docs/EN_Terms_and_conditions_React_2021.pdf';
  }
};

export const getPrivacyPolicyByLang = lang => {
  switch (lang) {
    case languages.ES:
      return 'https://s3.amazonaws.com/assets.bridgeforbillions.org/docs/ES_Politica_de_privacidad_React_2021.pdf';
    case languages.EN:
    default:
      return 'https://s3.amazonaws.com/assets.bridgeforbillions.org/docs/EN_privacy_policy_React_2021.pdf';
  }
};
